import PropTypes from 'prop-types';
import { priceDisplayFormat } from '@app/utils/paymentUtils';

const ProductUnitPrice = ({ currency, price, unitPrice }) => {
  const showUnitPrice = unitPrice && unitPrice !== price;
  return showUnitPrice ? (
    <p className={'text-md text-univers u-color--DarkGray'}>
      {priceDisplayFormat({
        price: unitPrice,
        currency,
        priceWrapperClasses:
          'text-md text-line-through text-univers u-color--DarkGray'
      })}
    </p>
  ) : null;
};

ProductUnitPrice.propTypes = {
  currency: PropTypes.string,
  price: PropTypes.string,
  unitPrice: PropTypes.string
};

export default ProductUnitPrice;
